import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5001/api' 
  : '/api';

export const rebatesApi = {
  // Public: Get all rebates
  getAll: async () => {
    const response = await axios.get(`${API_BASE}/rebates`);
    return response.data;
  },

  // Admin: Create new rebate
  create: async (rebateData, token) => {
    const response = await axios.post(`${API_BASE}/admin/rebates`, rebateData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Admin: Update rebate
  update: async (id, updates, token) => {
    const response = await axios.put(`${API_BASE}/admin/rebates/${id}`, updates, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Admin: Delete rebate
  delete: async (id, token) => {
    const response = await axios.delete(`${API_BASE}/admin/rebates/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Admin login (uses issues admin endpoint)
  adminLogin: async (email, password) => {
    const response = await axios.post(`${API_BASE}/admin/login`, { email, password });
    return response.data;
  }
};

export default rebatesApi;







